import { getCTATemplate } from "../../shortcodes/templates";
import { addShortcodeToEditor, getShortcodeWrapper } from "@/assets/utilities/tinymce/shortodeAddition";

const singleCTAConfig = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "Button CTA #1",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "ctaText",
          label: "Button text",
          placeholder: "Button text",
        },
        {
          type: "input",
          name: "url",
          label: "URL",
          placeholder: "https://domain.com",
        },
        {
          type: "selectbox",
          name: "openLink",
          label: "Open link in...",
          items: [
            { value: "_self", text: "Same window tab" },
            { value: "_blank", text: "New window tab" },
          ],
        },
        {
          type: "colorinput",
          name: "bgColor",
          label: "Button color",
        },
      ],
    },
    initialData: {
      bgColor: "#28b02b",
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getCTATemplate({
        text: data.ctaText,
        url: data.url,
        tab: data.openLink,
        bgColor: data.bgColor,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  });
};

export { singleCTAConfig };
